import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout      from './components/layout/Layout';
import Login       from './pages/Login';
import Dashboard   from './pages/Dashboard';
import Vehicles    from './pages/Vehicles';
import Drivers     from './pages/Drivers';
import Assignments from './pages/Assignments';
import Repairs     from './pages/Repairs';
import Fuel        from './pages/Fuel';
import Compliance  from './pages/Compliance';
import Users       from './pages/Users';
import Renewals    from './pages/Renewals';
import Settings    from './pages/Settings';
import Inventory   from './pages/Inventory';
import Garages     from './pages/Garages';
import Approvals   from './pages/Approvals';
import Invoices    from './pages/Invoices';
import Accidents   from './pages/Accidents';

const Placeholder = ({ title }) => (
  <div className="flex items-center justify-center h-64 bg-white rounded-xl border border-gray-200">
    <div className="text-center">
      <p className="text-4xl mb-2">🚧</p>
      <p className="text-lg font-semibold text-gray-700">{title}</p>
      <p className="text-sm text-gray-400 mt-1">Page coming soon</p>
    </div>
  </div>
);

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-primary-500">
      <div className="w-10 h-10 border-4 border-white/30 border-t-white rounded-full animate-spin" />
    </div>
  );
  return user ? children : <Navigate to="/login" replace />;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/*" element={
        <PrivateRoute>
          <Layout>
            <Routes>
              <Route path="/"            element={<Dashboard />} />
              <Route path="/vehicles"    element={<Vehicles />} />
              <Route path="/approvals"   element={<Approvals />} />
              <Route path="/invoices"    element={<Invoices />} />
              <Route path="/accidents"   element={<Accidents />} />
              <Route path="/drivers"     element={<Drivers />} />
              <Route path="/assignments" element={<Assignments />} />
              <Route path="/repairs"     element={<Repairs />} />
              <Route path="/fuel"        element={<Fuel />} />
              <Route path="/compliance"  element={<Compliance />} />
              <Route path="/inventory"   element={<Inventory />} />
              <Route path="/garages"     element={<Garages />} />
              <Route path="/users"       element={<Users />} />
              <Route path="/renewals"    element={<Renewals />} />
              <Route path="/settings"    element={<Settings />} />
              <Route path="*"            element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
        </PrivateRoute>
      } />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
